var map = {
	"./arrow.svg": "nCIC",
	"./direction.svg": "k58b",
	"./download.svg": "+H2/",
	"./products-bg.svg": "lV6p",
	"./quotation-mark.svg": "DdGL",
	"./square.svg": "rx/K",
	"./产品动画.svg": "011+",
	"./叉号.svg": "3YdP",
	"./复制.svg": "uCF6",
	"./方向2.svg": "8Err",
	"./菜单.svg": "dShQ",
	"./黑底.svg": "mRKH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 2